import { render, staticRenderFns } from "./batchOrder.vue?vue&type=template&id=6ca9b97c&scoped=true"
import script from "./batchOrder.vue?vue&type=script&lang=ts"
export * from "./batchOrder.vue?vue&type=script&lang=ts"
import style0 from "./batchOrder.vue?vue&type=style&index=0&id=6ca9b97c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9b97c",
  null
  
)

export default component.exports